module.exports = __webpack_public_path__ + "assets/adpoly-faculty-bulk-upload-template.7beb6a22.xlsx";